<template>
  <div class="insert-access-group">
    <vs-row>
      <vs-col>
        <custom-validate-input :label="$t('setting.accessGroup.insert.labels.name')"
                               :regex="$u.validator('regex.accessGroup.name')"
                               :invalid-text="''"
                               v-model="newAccessGroup.name"/>

        <custom-number-input :label="$t('setting.accessGroup.insert.labels.allowedActiveSession')"
                             classes="w-full"
                             v-model="newAccessGroup.activeSessionCount"/>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col>
        <span class="text-sm useral-text-colors text-blue--300">{{ $t('setting.accessGroup.insert.labels.access') }}</span>
        <span class="text-xs text-danger block w-full"></span>
      </vs-col>

      <custom-tree v-for="(permission, permission_index) in permissions"
                   :key="permission_index"
                   class="w-full"
                   :class="{'mt-2': permission.children.length > 0}"
                   :root="permission.children.length > 0"
                   :config="treeConfig"
                   :node="permission.node"
                   :children="permission.children"
                   v-model="selectedPermissions"/>
    </vs-row>

    <vs-button id="saveBTN" class="useral-action-button" @click="insertData"/>
  </div>
</template>

<script>
import CustomSelect from '@/components/customSelect/customSelect'
import CustomValidateInput from '../../../../../components/customInput/customValidateInput'
import CustomNumberInput from '../../../../../components/customInput/customNumberInput'
import CustomTree from '../../../../../components/Tree/CustomTree'
import {getPermissions, insertRole} from '../../../../../http/requests/roles'

export default {
  name: 'insertAccessGroup',
  metaInfo () {
    return {
      title: this.$t('setting.accessGroup.insert.title')
    }
  },
  components: {
    CustomTree,
    CustomNumberInput,
    CustomValidateInput,
    CustomSelect
  },
  props: {
    parentId: {
      type: Number,
      default: 0
    },
    availablePermissions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      newAccessGroup: {
        name: {
          value: '',
          isValid: false
        },
        activeSessionCount: {
          value: 3,
          isValid: true
        },
        permissions: []
      },
      treeConfig: {
        actions: [],
        collapse: true,
        selectable: true,
        parentSelectable: true
      },
      permissions: [],
      selectedPermissions: []
    }
  },
  created () {
    this.getPermissions()
  },
  methods: {
    getPermissions () {
      this.$u.loading.show()

      getPermissions().then(response => {
        const permissions = response.data.data
        permissions.forEach(permission => {
          this.permissions.push(this.createTree(permission, true))
        })

        this.$u.loading.hide()
      })

    },
    createTree (permission) {
      const children = []
      permission.children.forEach((child) => {
        children.push(this.createTree(child))
      })

      const node = {
        id: permission.id,
        label: permission.children.length > 0 ? `${permission.name} (${this.$t('setting.accessGroup.insert.labels.inMenu')})` : permission.name,
        show: false
      }
      if (this.availablePermissions.indexOf(permission.id) === -1) node.locked = true
      this.selectedPermissions.push(node)

      return {
        node,
        children
      }
    },
    insertData () {
      if (this.newAccessGroup.name.value === '') {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('setting.accessGroup.insert.validators.nameCantEmpty'),
          color: 'danger',
          time: 2400,
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
        return false
      } else if (!this.newAccessGroup.name.isValid) {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('setting.accessGroup.insert.validators.name'),
          color: 'danger',
          time: 2400,
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
        return false
      } else if (this.newAccessGroup.activeSessionCount.value > 5) {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('setting.accessGroup.insert.validators.activeSessionCount'),
          color: 'danger',
          time: 2400,
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
        return false
      }

      const role = {
        'name': this.newAccessGroup.name.value,
        'allowed_active_sessions': this.newAccessGroup.activeSessionCount.value,
        'permissions': []
      }

      if (this.parentId) {
        role.parent_id = this.parentId
      }

      role.permissions = this.selectedPermissions.filter((permission) => {
        return permission.show === true
      }).map((permission) => {
        return permission.id
      })

      if (role.permissions.length === 0) {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('setting.accessGroup.insert.validators.permissions'),
          color: 'danger',
          time: 2400,
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
        return false
      }

      insertRole(role).then(() => {
        this.$emit('insert')
        this.$store.dispatch('helper/changeRole')

        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('setting.accessGroup.notifications.insert.success'),
          time: 2400,
          color: 'success',
          icon: 'icon-check',
          iconPack: 'feather'
        })
      })
        .catch(() => {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('setting.accessGroup.notifications.insert.error'),
            color: 'danger',
            time: 2400,
            icon: 'icon-alert-circle',
            iconPack: 'feather'
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
